import { CSSProperties } from 'react'
import { Field, RowField, ArrayField, JSONField } from 'payload'
import { FieldDefault, FieldWithouType } from '@utils/fields'
import { mergeObjects } from '@utils/objects'

/**
 * Creates a RowField for Payload
 *
 * @param fields
 * @param width
 * @param config
 * @returns
 */
export function rowField(fields: CustomPayloadField<Field>[], width: CSSProperties['width'] = '50%', config?: Omit<FieldWithouType<RowField>, 'fields'>): RowField[] {
  const row: FieldDefault<RowField> = {
    type: 'row',
    admin: {
      className: `row-with-${width.toString().replace(/[^0-9]/g, '')}-width`
    },
    fields: fields.map((field: any) => ({
      ...field,
      admin: {
        ...field.admin,
        width: field.admin?.width || width,
      }
    }))
  };

  return [ mergeObjects(config, row) ];
}

/**
 * Creates a Array Field for Payload
 *
 * @param config
 * @param inline
 * @returns
 */
export function arrayField(config: WithOneRequired<FieldWithouType<CustomPayloadField<ArrayField>>, 'labels' | 'fields'>, labelFormat?: string): ArrayField[] {
  const defaultConfig: Omit<FieldDefault<ArrayField>, 'fields'> = {
    type: 'array',
    admin: {
      isSortable: false,
      initCollapsed: true,
      components: {
        RowLabel: {
          path: '@components/(payload)/fields/array/row-label',
          serverProps: {
            labelFormat,
          }
        }
      }
    },
  };

  if (config.fields.length === 1) {
    config.fields[0]['label'] = '';
  }

  return [ mergeObjects(defaultConfig, config) ];
}

/**
 * Creates a Array Field for Payload
 *
 * @param config
 * @param inline
 * @returns
 */
export function arrayFieldInline(config: WithOneRequired<FieldWithouType<CustomPayloadField<ArrayField>>, 'labels' | 'fields'>, labelFormat?: string): ArrayField[] {
  const className = `${(config.admin?.className || '') } inline-array-field`;
  return arrayField( mergeObjects(config, { admin: { className } }), labelFormat );
}

/**
 * Creates a virtual JSON Field for Payload
 *
 * @param config
 * @returns
 */
export function virtualJsonField(config: FieldWithouType<CustomPayloadField<JSONField>>): JSONField[] {
  const configDefault: FieldDefault<JSONField> = {
    type: 'json',
    virtual: true,
    admin: {
      hidden: true,
    }
  };

  return [ mergeObjects(configDefault, config) ];
}
